import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const transactionExportsListColumns = [
  'transactionExports._id',
  'transactionExports.exportType',
  'transactionExports.status',
  'transactionExports.createdAt',
  'transactionExports.finishedOn',
  'transactionExports.filename',
  'transactionExports.download',
] as const;

export type TransactionExportsListColumns = (typeof transactionExportsListColumns)[number];

export type TransactionExportsListFilter = {
  'transactionExports._id': string | undefined;
  'transactionExports.exportType': string | undefined;
  'transactionExports.status': string | undefined;
  'transactionExports.createdAt': string | undefined;
  'transactionExports.finishedOn': string | undefined;
  'transactionExports.filename': string | undefined;
  'transactionExports.download': string | undefined;
};

export const defaultTransactionExportsListFilter: TransactionExportsListFilter = {
  'transactionExports._id': undefined,
  'transactionExports.exportType': undefined,
  'transactionExports.status': undefined,
  'transactionExports.createdAt': undefined,
  'transactionExports.finishedOn': undefined,
  'transactionExports.filename': undefined,
  'transactionExports.download': undefined,
};

export const transactionExportsListColumnVisibilitySettings = {
  'transactionExports._id': ColumnVisibilityType.CanBeHidden,
  'transactionExports.exportType': ColumnVisibilityType.CanBeHidden,
  'transactionExports.status': ColumnVisibilityType.CanBeHidden,
  'transactionExports.createdAt': ColumnVisibilityType.CanBeHidden,
  'transactionExports.finishedOn': ColumnVisibilityType.CanBeHidden,
  'transactionExports.filename': ColumnVisibilityType.CanBeHidden,
  'transactionExports.download': ColumnVisibilityType.CanBeHidden,
} satisfies ColumnVisibilitySettings<TransactionExportsListColumns>;

export const defaultTransactionExportsListColumnVisibility = defaultColumnVisibilityParams(
  transactionExportsListColumnVisibilitySettings
);

export const transactionExportsListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  transactionExportsListColumns,
  transactionExportsListColumnVisibilitySettings
);
